export default __webpack_public_path__ + "static/media/img_pow.700ff3cb.png";